import { createPortal } from "react-dom";
import type { PieceJointe, VariablesData } from "../../lib/types";
import { getPieceJointeContentComponent } from "../contenu-pieces-jointes";

interface AttachmentViewerModalProps {
  attachment: PieceJointe;
  variablesData: VariablesData;
  onClose: () => void;
}

export function AttachmentViewerModal({
  attachment,
  variablesData,
  onClose,
}: AttachmentViewerModalProps) {
  const ContentComponent = getPieceJointeContentComponent(attachment.cle);

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative max-h-[80vh] w-full max-w-3xl mx-4 overflow-auto rounded-surface bg-card p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-2 transition-colors duration-150 hover:bg-charte-hover-strong hover:text-accent-foreground"
        >
          ✕
        </button>
        <h2 className="mb-4 text-xl font-bold text-gray-900">
          {attachment.titre}
        </h2>
        <div className="prose prose-sm max-w-none text-gray-700">
          {ContentComponent ? (
            <ContentComponent variablesData={variablesData} />
          ) : (
            <p className="text-muted-foreground italic">
              Contenu de la pièce jointe non disponible
            </p>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
}
